
<div style="margin-left: 30px;z-index: 4;" >
    <div class="input-wrapper slected-input" (click)="toggleDropDown()" #myInput>
        <p>{{selectedValue}}</p>
        <img src="assets/drop-down-arrow.svg" alt="" class="arrow" [ngClass]="{'open-arrow': open,'close-arrow':!open}"/>
    </div>

        <div class="dropdown-wrapper" [ngClass]="{'open': open,'close':!open}" #dropdown>
            <div class="dropdown-container">
                <div class="search-container slected-input" [ngClass]="{'input-focus':inputFocused}" >
                    <img src="assets/images/search-icon.svg" *ngIf="!inputFocused" alt="" class="arrow"/>
                    <input type="text"  [formControl]="searchControl"  class="" (click)="focus()" placeholder="Search">
                    <img src="assets/cross.svg" *ngIf="inputFocused" alt="" class="arrow" (click)="focus()"/>

                </div>
                <div class="option-wrapper" *ngIf="optionsLength">
                    <div *ngFor="let item of filteredOptions|async" (click)="optionClicked(item)"><span>{{item.label}}</span></div>
                </div>
                <div class="option-wrapper no-option-wrapper" *ngIf="!optionsLength">
                     <div ><span style="color: #6A737D;">Cost Centre not avalaible</span></div>
                </div>
                <div (click)="addOption()" class="add-option-wrapper"><span >+ New Cost Centre</span></div>
            </div>
        </div>
</div>

<app-popover *ngIf="openPopup"  (closeCallback)="openPopup=false" size="addCaboption-model">
    <div popover-header class="popover-header font-weight-700">Add New Cost Centre</div>
    <div popover-content class="add-costcenter-container">
        <div>
            <span>Name</span>
            <input type="text"  [formControl]="newCostCenterName" (click)="focus()">
        </div>
    </div>
    <div popover-actions class="submit-button">
        <app-button type="plainText" text="Clear" class="mr-20" (clickCallback)="clear()"
          ></app-button>
        <app-button type="primaryFilled" text="Submit" (clickCallback)="submitCostCenter()"
          [btnType]="'successBtn'" [disabled]="!newCostCenterName['value'].length"></app-button>
      </div>
</app-popover>
<app-toast *ngIf="costCentedAddedToas" message="Costcenter Added Successfully" (dismissCallback)="toggleToast()">
</app-toast>
    
<div class="overlay" [ngClass]="{'open-overlay': open,'close-overlay':!open}" (click)="toggleDropDown()"></div>
